export default "__VITE_ASSET__DHLTz7$p__"